export default "__VITE_ASSET__B5El57b0__"